import Funcs from 'common/helpers/Funcs';
import NavigationService from 'common/services/NavigationService';
import AppConst from 'consts/AppConst';
import ScreenConst from 'consts/ScreenConst';
import RNCodePush from '@code-push-next/react-native-code-push';
import SimpleToast from 'react-native-simple-toast';
import Store from 'states/redux/Store';
import Configs from 'utils/Configs';
import StorageService from './StorageService';
import Time from 'common/helpers/Time';

// import fs from 'react-native-fs';
// Funcs.log('fs.DocumentDirectoryPath', fs.DocumentDirectoryPath);

const CODEPUSH_LAST_CHECK_TIME = 'CODEPUSH_LAST_CHECK_TIME';
const CODEPUSH_DELAY_RESTART = 'CODEPUSH_DELAY_RESTART';

var hasNewVersion = false;

export default {
  checkForUpdate: () => {
    return RNCodePush.checkForUpdate();
  },

  getCurrentInfo: async () => {
    const data = await RNCodePush.getUpdateMetadata();
    return data;
  },

  resetCodepushData: async () => {
    RNCodePush.clearUpdates();
  },

  restartApp: async () => {
    RNCodePush.restartApp();
  },

  sync: async (force) => {
    // Check nếu có hàng hoá trong giỏ hàng, thì bỏ sync
    let { listCartItem = [] } = Store.getState()?.homeReducer;
    if (listCartItem?.length > 0) return;
    function showToast(message) {
      if (!Configs?.user || Configs?.user?.id !== 1) return;
      if (!AppConst.IS_DEV_BUILD) return;
      SimpleToast.show(message);
    }
    function delayRestartApp() {
      try {
        // Check màn hình chỗ này, nếu là đang ở trang chủ, danh sách item trong cart ko có thì mới restart.
        let currentScreen = '';
        const route = NavigationService.getCurrentRouter();
        const routes = route?.state?.routes;
        const index = route?.state?.index || 0;
        if (routes?.length > index) currentScreen = routes[index]?.name;
        Funcs.log('Codepush current screen', currentScreen);
        if (currentScreen === ScreenConst.HOME_SCREEN) {
          Funcs.log('Codepush service check listCartItem', listCartItem);

          // Nếu ko phải là force và giỏ hàng có item thì đợi
          if (!force && listCartItem?.length > 0) {
            Funcs.log('Codepush service delay restart!!!');
            showToast('CP delay restart!');
            StorageService.save(CODEPUSH_DELAY_RESTART, Date.now());
            return false;
          }
          RNCodePush.restartApp();
        }
      } catch (err) {
        console.log('ERROR', err);
      }
    }

    // Check delay restart
    let delayRestart = (await StorageService.get(CODEPUSH_DELAY_RESTART)) || 0;
    if (delayRestart) {
      Funcs.log('Codepush service check delay restart!!!');
      StorageService.remove(CODEPUSH_DELAY_RESTART);
      delayRestartApp();
      return;
    }

    // Delay check
    try {
      // Nếu có delay time. thì check sau.
      let delayTimeTo = (await StorageService.get('CODEPUSH_DELAY_CHECK_TIME_TO')) || 0;
      delayTimeTo = parseInt(delayTimeTo);
      if (!force && Date.now() < delayTimeTo) {
        const mess = 'CP delay to ' + Time.format(delayTimeTo) + 's';
        Funcs.log(mess);
        showToast(mess);
        return;
      }

      // Delay sau 5 phút mới check 1 lần
      let lastSync = (await StorageService.get(CODEPUSH_LAST_CHECK_TIME)) || 0;
      lastSync = parseInt(lastSync);
      if (!force && Date.now() < lastSync + 5 * 60 * 1000) {
        const mess = 'CP delay after ' + (lastSync + 5 * 60 * 1000 - Date.now()) / 1000 + 's';
        Funcs.log(mess);
        showToast(mess);
        return;
      }
    } catch (err) {
      console.log('ERROR', err);
    }

    // Check
    Funcs.log('Codepush service sync');
    if (__DEV__) return;
    try {
      Funcs.log('===> Codepush service check');
      showToast('CP check');
      RNCodePush.sync(
        { installMode: RNCodePush.InstallMode.IMMEDIATE, mandatoryInstallMode: RNCodePush.InstallMode.IMMEDIATE },
        (status) => {
          Funcs.log('Codepush service status', status);
          showToast('CP status' + status);
          switch (status) {
            case RNCodePush.SyncStatus.DOWNLOADING_PACKAGE:
              showToast('DOWNLOADING_PACKAGE');
              Funcs.log('Codepush service downloading...');
              break;
            case RNCodePush.SyncStatus.INSTALLING_UPDATE:
              showToast('INSTALLING_UPDATE');
              Funcs.log('Codepush service installing...');
              hasNewVersion = true;
              break;
            case RNCodePush.SyncStatus.UPDATE_INSTALLED:
              showToast('UPDATE_INSTALLED');
              Funcs.log('Codepush service installed!', { hasNewVersion });
              if (!hasNewVersion) break;
              delayRestartApp();
              break;
            case RNCodePush.SyncStatus.UPDATE_IGNORED:
              Funcs.log('Codepush service install ignored!');
              showToast('UPDATE_IGNORED');
              break;
            case RNCodePush.SyncStatus.UNKNOWN_ERROR:
              Funcs.log('Codepush service install error!');
              showToast('UNKNOWN_ERROR');
              break;
            default:
              break;
          }
        },
        ({ receivedBytes, totalBytes }) => {
          var downloadProgress = parseInt((receivedBytes * 100) / totalBytes);
          Funcs.log('Codepush download progress', downloadProgress);
        }
      );
    } catch (error) {
      Funcs.log('Codepush error', error);
    }
    StorageService.save(CODEPUSH_LAST_CHECK_TIME, Date.now());
  },

  release: () => {
    Funcs.log('Codepush service release!!!');
    StorageService.remove(CODEPUSH_DELAY_RESTART);
    StorageService.remove(CODEPUSH_LAST_CHECK_TIME);
  }
};
